import api from "./cofocusAPI";

/**
 * To reduce file size and repetitiveness
 */
async function getResponseData(requestConfig) {
  try {
    const response = await api.REQUEST(requestConfig);
    if (response && response.data && response.data.success) {
      return response.data;
    }
  } catch (error) {
    console.error("error with config: ", requestConfig);
  }
  return null;
}

async function getProfileData(userID) {
  return getResponseData({
    url: `/api/users/${userID}/profile`,
    method: "get",
    withCredentials: true,
  });
}

async function getOneUserByUID(UID) {
  if (!UID) return { success: false };
  return getResponseData({
    url: `/api/users/${UID}`,
    method: "get",
    withCredentials: true,
  });
}

function updateConnectionStatus(connectionID, senderID, receiverID, action, currentUserID) {
  if (!action) return null;
  const data = {
    action,
  };
  if (action !== "connect") {
    if (!connectionID) return null;
    data.CID = connectionID;
  }
  if (senderID) data.sender = senderID;
  if (receiverID) data.receiver = receiverID;
  return getResponseData({
    url: `api/users/${currentUserID}/connect-requests`,
    method: "post",
    data,
    withCredentials: true,
  });
}

async function acceptConnectRequest(connectionID, currentUserID, senderID) {
  return updateConnectionStatus(connectionID, senderID, null, "accept", currentUserID);
}
async function rejectConnectRequest(connectionID, currentUserID, senderID) {
  return updateConnectionStatus(connectionID, senderID, null, "reject", currentUserID);
}
async function cancelConnectRequest(connectionID, currentUserID, receiverID) {
  return updateConnectionStatus(connectionID, null, receiverID, "cancel", currentUserID);
}
async function sendConnectRequest(currentUserID, receiverID) {
  return updateConnectionStatus(null, null, receiverID, "connect", currentUserID);
}
async function unconnect(connectionID, currentUserID) {
  return updateConnectionStatus(connectionID, null, null, "unconnect", currentUserID);
}

async function getConnections(userID, limit, skip) {
  return getResponseData({
    url: `api/users/${userID}/connections`,
    method: "get",
    params: {
      skip: skip,
      limit: limit,
    },
    withCredentials: true,
  });
}

async function getConnectRequests(userID, limit, skip, getSentRequests) {
  return getResponseData({
    url: `api/users/${userID}/connect-requests`,
    method: "get",
    params: {
      skip: skip,
      limit: limit,
      sent: getSentRequests ? 1 : 0,
    },
    withCredentials: true,
  });
}

async function getPartnerSessionCount(partnerID) {
  return getResponseData({
    url: `api/users/${partnerID}/sessionCount`,
    method: "get",
    params: {
      partnerID,
    },
    withCredentials: true,
  });
}

async function excludeUser(excluderID, excludedID, expireValue, updating = false) {
  if (!excluderID || !excludedID || (!expireValue && expireValue !== 0)) return alert("rip");
  const data = {
    excluderID,
    excludedID,
    status: "EXCLUDED",
    expireValue,
  };
  if (updating) data.updating = true;
  return getResponseData({
    url: `api/users/${excluderID}/exclude`,
    method: "post",
    data,
    withCredentials: true,
  });
}

async function unexcludeUser(excluderID, excludedID) {
  if (!excluderID || !excludedID) return null;
  const data = {
    excluderID,
    excludedID,
  };
  return getResponseData({
    url: `api/users/${excluderID}/unexclude`,
    method: "post",
    data,
    withCredentials: true,
  });
}

async function blockUser(blockerID, blockedID) {
  if (!blockerID || !blockedID) return null;
  const data = {
    blockerID,
    blockedID,
    status: "BLOCKED",
  };
  return getResponseData({
    url: `api/users/${blockerID}/block`,
    method: "post",
    data,
    withCredentials: true,
  });
}

async function unblockUser(blockerID, blockedID) {
  if (!blockerID || !blockedID) return null;
  const data = {
    blockerID,
    blockedID,
  };
  return getResponseData({
    url: `api/users/${blockerID}/unblock`,
    method: "post",
    data,
    withCredentials: true,
  });
}

async function getUserBlockedOrExcludedData(UID, listType, lastQueriedDate) {
  if (!UID) return null;
  return await api.getResponseData({
    url: `/api/users/${UID}/blockedOrExcludedData`,
    method: "get",
    params: {
      UID,
      listType,
      lastQueriedDate,
    },
    withCredentials: true,
  });
}

export default {
  getProfileData,
  getOneUserByUID,
  acceptConnectRequest,
  rejectConnectRequest,
  cancelConnectRequest,
  sendConnectRequest,
  unconnect,
  getConnections,
  getConnectRequests,
  getPartnerSessionCount,
  blockUser,
  unblockUser,
  unexcludeUser,
  excludeUser,
  getUserBlockedOrExcludedData,
};
